import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'

/**
* Star icon.
*/
function StarIcon(props) {
  const {
    isFull, isHalf, isEmpty, ...rest
  } = props

  let name; let
    content

  // Half star.
  if (isHalf) {
    name = 'star-half'
    content = (
      <g><path d="M22 9.74l-7.19-.62L12 2.5 9.19 9.13 2 9.74l5.46 4.73-1.64 7.03L12 17.77l6.18 3.73-1.63-7.03L22 9.74zM12 15.9V6.6l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.9z" /></g>
    )
  // Empty star.
  } else if (isEmpty) {
    name = 'star-outline'
    content = (
      <g><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" /></g>
    )
  // Default to full star.
  } else {
    name = 'star'
    content = (
      <g><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></g>
    )
  }

  return (
    <Icon
      icon={name}
      aria-hidden
      role="presentation"
      {...rest}
    >
      {content}
    </Icon>
  )
}

StarIcon.defaultProps = {
  isFull: false,
  isHalf: false,
  isEmpty: false,
}

StarIcon.propTypes = {
  isFull: PropTypes.bool,
  isHalf: PropTypes.bool,
  isEmpty: PropTypes.bool,
}

export default StarIcon
